export const Logo = ({ size = 28, withText = true }) => (
  <div className="flex items-center gap-2.5" data-testid="eduos-logo">
    <div
      className="relative flex items-center justify-center bg-[hsl(244_53%_20%)] text-white rounded-md"
      style={{ width: size, height: size }}
    >
      <span className="font-heading font-extrabold text-[13px] tracking-tight">e</span>
      <span className="absolute -right-0.5 -top-0.5 w-1.5 h-1.5 rounded-full bg-[hsl(20_90%_48%)]" />
    </div>
    {withText && (
      <span className="font-heading font-bold text-[15px] tracking-tight">
        EduOS<span className="text-[hsl(20_90%_48%)]">.</span>
      </span>
    )}
  </div>
);

export default Logo;
